import React, { createContext, useState } from "react";
import {
  isAuthenticated,
  selectDiscoveryId,
  selectDiscoverySetting
} from "../../../store/reducers";
import { bindActionCreators, compose } from "redux";
import { updateDiscoverySettings } from "../../../store/actions/discoveries";
import { connect } from "react-redux";
import ViewValueHypothesisKPIsBy from "../../../utils/view-value-hypothesis-kpis-by";

export const ValueHypothesisContext = createContext();

const ValueHypothesisProvider = ({
  discoveryId,
  isAuthenticated,
  updateDiscoverySettings,
  viewValueHypothesisKPIsBy,
  reportMode,
  children
}) => {
  // Local state for report mode (not persisted)
  const [localSortBy, setLocalSortBy] = useState(null);

  // Use local state in report mode, otherwise use discovery setting
  const sortBy = reportMode
    ? localSortBy || viewValueHypothesisKPIsBy
    : viewValueHypothesisKPIsBy;

  const updateSortBy = (newValue) => {
    if (reportMode) {
      // In report mode, only update local state (not saved)
      setLocalSortBy(newValue);
    } else {
      // In discovery mode, save to backend
      if (isAuthenticated) {
        updateDiscoverySettings({
          discoveryId,
          changes: { viewValueHypothesisKPIsBy: newValue }
        });
      }
    }
  };

  return (
    <ValueHypothesisContext.Provider
      value={{
        sortBy,
        updateSortBy,
        reportMode
      }}
    >
      {children}
    </ValueHypothesisContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  viewValueHypothesisKPIsBy: selectDiscoverySetting(
    state,
    "viewValueHypothesisKPIsBy",
    ViewValueHypothesisKPIsBy.VALUE
  ),
  discoveryId: selectDiscoveryId(state),
  isAuthenticated: isAuthenticated(state)
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDiscoverySettings
    },
    dispatch
  );

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ValueHypothesisProvider
);
